import { render, staticRenderFns } from "./LastMileDispatchModal.vue?vue&type=template&id=17dc056c&scoped=true"
import script from "./LastMileDispatchModal.vue?vue&type=script&lang=js"
export * from "./LastMileDispatchModal.vue?vue&type=script&lang=js"
import style0 from "./LastMileDispatchModal.vue?vue&type=style&index=0&id=17dc056c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc056c",
  null
  
)

export default component.exports